var map = {
	"./academic.svg": "7b28",
	"./antecedents.svg": "748e",
	"./datacredito.svg": "2445",
	"./laboral.svg": "014e",
	"./on-boarding.svg": "5373",
	"./personal.svg": "fdf8",
	"./polygraph.svg": "2358",
	"./psychotechnical.svg": "77a8",
	"./remote-work-visit.svg": "bea5",
	"./visit.svg": "3e95"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9c1e";